import { render } from "./SettingsLogo.vue?vue&type=template&id=31cfcf85"
import script from "./SettingsLogo.vue?vue&type=script&lang=js"
export * from "./SettingsLogo.vue?vue&type=script&lang=js"
script.render = render

export default script